<script setup>
import config from '@/common/config'
import { down, post, postMultipart, qsel, serverDt, validators, ymd } from '@/common/util'
import { useMetaStore } from '@/stores'
import dayjs from 'dayjs'
import _ from 'lodash-es'
import { reactive } from 'vue'
const metaStore=useMetaStore(),meta=reactive({search:{page:1,size:20,sortcol:'mdt',dtcol:'mdt',isasc:false},searchcols:['author','title'],selsearchcol:'author',tblheight:400
  ,heads:[{tkey:'uid',col:'id'},{tkey:'author'},{tkey:'dateofmod',col:'mdt'},{tkey:'title',col:'ttl'},{tkey:'xcoordinate',col:'xpos'},{tkey:'ycoordinate',col:'ypos'},{tkey:'viewdetails'},{tkey:'delete'}]})
,delMemoImg=async(id)=>{
  if(id){
    if(!confirm(metaStore.t('del_con')))return
    const res=await post('rest/authed/admin/data/delmemoimg',{id:id})
    metaStore.toastRslt(res,false)
  }
  meta.selmemo.file=null
  qsel(`.admmemoimgwrap`).classList.add('d-none')
},delMemo=async(id)=>{
  metaStore.blockLoading()
  const res=await post('rest/authed/admin/data/delmemo',{id:id})
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,false)
  search()
},save=async()=>{
  metaStore.blockLoading()
  const res=await postMultipart('rest/authed/admin/data/savememo',meta.selmemo)
  metaStore.blockLoading(false)
  metaStore.toastRslt(res,true)
  memoDetailPop()
  search()
},memoImgChanged=async()=>{
  const img=qsel('.admmemoimg')
  if(meta.selmemo.file){
    img.src=window.URL.createObjectURL(meta.selmemo.file)
    img.parentElement.classList.remove('d-none')
  }else img.parentElement.classList.add('d-none')
},memoDetailPop=async(id)=>{
  meta.selmemo=null
  metaStore.pop({ison:id!=null,callback:async()=>{
    if(!id)return
    meta.selmemo={...meta.data.rows.find(memo=>memo.id==id)}
    if(!meta.selmemo)return
    const files=await post(`rest/authed/member/attachedfiles`,{tartbl:'Memo',refids:[id]})
    const img=qsel('.admmemoimg')
    if(files.data.length){
      img.src=config.backend+'attachedfile/'+files.data[0].id
      img.parentElement.classList.remove('d-none')
    }else img.parentElement.classList.add('d-none')
  }})
},download=()=>{
  const pd={}
  if(!_.isEmpty(meta.searchval))pd[meta.selsearchcol]=meta.searchval
  metaStore.blockLoading()
  down({url:'rest/authed/admin/data/downmemo',data:pd})
  setTimeout(() =>metaStore.blockLoading(false),2000)
},search=async(page=1,head)=>{
  meta.search.page=page
  meta.search.where={}
  if(head&&head.col){
    if(meta.search.sortcol==head.col)meta.search.isasc=!meta.search.isasc
    else meta.search.isasc=true
    meta.search.sortcol=head.col
  }
  if(!_.isEmpty(meta.searchval))meta.search.where[meta.selsearchcol]=meta.searchval
  if(meta.dtrange[0]){
    meta.dtrange[0].setHours(0, 0, 0, 0)
    meta.search.dtst=serverDt(meta.dtrange[0])
  }
  if(meta.dtrange.length>1)meta.search.dted=serverDt(dayjs(_.last(meta.dtrange)).add(1,'day').toDate())
  metaStore.blockLoading(true)
  const res=await post('rest/authed/admin/data/searchmemo',meta.search)
  metaStore.blockLoading(false)
  meta.data=res.data
  meta.tblheight=window.innerHeight-440
}
meta.dtrange=[dayjs().subtract(30,'day').toDate(),new Date]
search()
</script>
<template>
  <v-card flat class="admmemo" width="100%" height="100%" :title="$t('manageroadviewnotes')">
    <v-sheet class="pa-3 bg-grey-lighten-3">
      <v-row>
        <v-col cols="4">
            <v-date-input clearable hide-details variant="outlined" density="compact" prepend-icon="" prepend-inner-icon="$calendar" v-model="meta.dtrange" :label="$t('select_range')" multiple="range" @click:clear="meta.dtrange=[]"/>
        </v-col>
        <v-col>
          <v-btn :text="$t('today')" class="me-2" @click="meta.dtrange=[new Date,new Date]"/>
          <v-btn :text="$t('yesterday')" class="me-2" @click="meta.dtrange=[dayjs().subtract(1,'day').toDate(),new Date]"/>
          <v-btn :text="$t('7daysago')" class="me-2" @click="meta.dtrange=[dayjs().subtract(7,'day').toDate(),new Date]"/>
          <v-btn :text="$t('30daysago')" @click="meta.dtrange=[dayjs().subtract(30,'day').toDate(),new Date]"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-select hide-details variant="outlined" density="compact" :items="meta.searchcols" v-model="meta.selsearchcol" :item-title="item=>$t(item)" :item-value="val=>val"/>
        </v-col>
        <v-col>
          <v-text-field hide-details variant="outlined" density="compact" :placeholder="$t('enteryoursearchterm')" v-model="meta.searchval"/>
        </v-col>
        <v-col>
          <v-btn prepend-icon="mdi-magnify" color="secondary" :text="$t('search')" @click="search()"/>
        </v-col>
        <v-col class="text-right">
          <v-btn prepend-icon="mdi-download-box-outline" color="primary" :text="$t('download')" @click="download()"/>
        </v-col>
      </v-row>
    </v-sheet><v-card-text>
      <v-table fixed-header v-if="meta.data" :height="meta.tblheight">
        <thead>
          <tr><th v-for="head in meta.heads">
            <div v-if="head.col" class="cursor-pointer" @click="search(1,head)">
              {{ $t(head.tkey) }}
              <v-icon v-if="meta.search.sortcol!=null&&head.col==meta.search.sortcol" :icon="meta.search.isasc?'mdi-arrow-up':'mdi-arrow-down'"/>
            </div>
            <div v-else>{{ $t(head.tkey) }}</div>
          </th></tr>
        </thead>
        <tbody>
          <tr v-for="row in meta.data.rows">
            <td v-for="head in meta.heads">
              <div v-if="head.col=='mdt'">{{ ymd(row[head.col]) }}</div>
              <div v-else-if="head.tkey=='author'">{{ meta.data.subrows.mems.find(mem=>mem.mid==row.createrid)?.mname }}</div>
              <div v-else-if="head.col">{{ row[head.col] }}</div>
              <v-btn v-else :text="$t(head.tkey)" :color="head.tkey=='delete'?'error':''" @click="()=>{
                if(head.tkey=='delete')metaStore.dialog({shown:true,ttl:'manageroadviewnotes',cont:'del_con',showcancel:true,istk:true,onok:()=>delMemo(row.id)})
                else memoDetailPop(row.id)
              }"/>
            </td>
          </tr>
        </tbody>
      </v-table>
    </v-card-text>
    <v-card-actions>
      <v-pagination class="ma-auto" v-if="meta.data&&meta.data.rows.length>0" :length="meta.data.totalPages" :total-visible="meta.data.pageCount" v-model="meta.page" @update:model-value="search"/>
    </v-card-actions>
  </v-card>
  <Teleport v-if="meta.selmemo" to="#popbody">
    <v-card flat width="400">
      <v-card-title>
        <v-row>
          <v-col>{{ $t('mynotes') }}</v-col>
          <v-col cols="3" class="text-right"><v-btn variant="flat" density="compact" icon="mdi-close" @click="memoDetailPop()"/></v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-text-field variant="outlined" density="compact" :label="$t('title')" :placeholder="$t('enteratitleupto50characters')" :rules="[validators.required]" v-model="meta.selmemo.ttl"/>
        <v-textarea variant="outlined" density="compact" :label="$t('contents')" :placeholder="$t('enteryourcontentupto500')" :rules="[validators.required]" v-model="meta.selmemo.cont"/>
        <p>{{ $t('coordinates') }}</p>
        <v-row class="mb-2">
          <v-col><v-text-field hide-details variant="outlined" density="compact" readonly v-model="meta.selmemo.xpos"/></v-col>
          <v-col><v-text-field hide-details variant="outlined" density="compact" readonly v-model="meta.selmemo.ypos"/></v-col>
        </v-row>
        <v-text-field class="mb-2" hide-details variant="outlined" density="compact" readonly :label="$t('addressinformation')" v-model="meta.selmemo.addr"/>
        <div class="d-none admmemoimgwrap border-thin ma-3">
          <img class="admmemoimg" style="max-width: 100%;max-height: 300px;"/>
          <img class="memoimgdel" :src="config.frontRoot+'close_circle.png'" width="32" style="position: absolute;top: -16px;right: -16px;cursor: pointer;" @click="delMemoImg(meta.selmemo?.id)"/>
        </div>
        <v-file-input show-size hide-details variant="outlined" density="compact" v-model="meta.selmemo.file" @update:model-value="memoImgChanged"/>
      </v-card-text>
      <v-card-actions>
        <v-row>
          <v-col><v-btn block variant="elevated" :text="$t('cancel')" @click="memoDetailPop()"/></v-col>
          <v-col><v-btn block variant="elevated" color="primary" :text="$t('save')" @click="save" :disabled="_.isEmpty(meta.selmemo.ttl)||_.isEmpty(meta.selmemo.cont)"/></v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </Teleport>
</template>
<style>
.admmemo .v-input__control{background-color: rgba(255,255,255,1);}
.admmemoimgwrap{position: relative;display: inline-block;}
</style>
